import { useSelector } from 'react-redux';
import { supabase } from '../supabaseClient';
import { errorTost, offlineToast } from './Toast';
let i = 0;
async function loginWithEmailPass(email, password) {
  const { data, error } = await supabase.auth.signIn({
    email: email,
    password: password,
  })
  if (data) return data;
  else throw error;
}
async function signOut() {
  return await supabase.auth.signOut()
}
async function getUser(email) {
  const { data, error } = await supabase
    .from('Users').select('*,roleId(*),parentId(*)').eq('email', email)
  if (data) return data;
  else throw error;
}
//getAll users except currentOne
async function getAllUser(currentOne) {
  let query = await supabase.from('Users').select('*,roleId(*),parentId(*)');
  
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
async function getAllUserActive(currentOne) {
  let query= await supabase.from('Users').select('*,roleId(*),parentId(*)').eq("isActive", true);
  
  const { data, error } = query;
  if (data) return data;
  else throw error;
}
async function getAllUserByName(name) {
  var query;

  query = await supabase.from('Users').select('*,roleId(*)').ilike('name', `%${name}%`);

  const { data, error } = query;
  if (data) return data;
  else throw error;
}
function handleErrors(error, page, data) {
  console.log(page, ':', error);
  if (error?.message?.includes('FetchError: Failed to fetch')) {
    // if (!window.navigator.onLine) {
    offlineToast();
  } else {
    if (
      error?.message?.includes(
        'duplicate key value violates unique constraint "CP_billingName_key"'
      )
    ) {
      errorTost(
        `CP with Billing Name ${data} already exists`
      );
    } else if (error?.message?.includes("User already registered")) {
      errorTost("Contact Person already exists");
    }
    else {
      errorTost(error.message);
    }
  }
}

async function insertLoginLogs(obj) {
  const { data, error } = await supabase.from('LoginLogs').insert(obj)
  if (data) return data
  else throw error
}
async function getUserId(userIds, resolve) {
  // return new Promise(async (resolve, reject) => {

  const { data, error } = await supabase.from('Users').select('*').eq('parentId', userIds[i])
  if (data) {
    console.log('data: ', data);
    data.forEach((id) => {
      userIds.push(id.userId)
    });
    i++;
    if (i === userIds.length) {
      console.log('userIds: ', userIds);
      localStorage.setItem('teamIds', JSON.stringify(userIds));
      resolve(true);
    } else {
      getUserId(userIds, resolve);
    }
  }
  // else throw error
  // });
}

async function getUsers1(userIds,resolve) {
  // return new Promise(async (resolve, reject) => {
  
  const { data, error } = await supabase
    .from("Users")
    .select("*")
  if (data) {
    console.log("data: ", data);
    data.forEach((id) => {
      userIds.push(id.userId);
    });
      localStorage.setItem("teamIds", JSON.stringify(userIds));
      resolve(true);
    
  }
  // else throw error
  // });
}
async function getTeamHierarchy(loggedInUser) {
  return new Promise((resolve, reject) => {
    const userIDs = [];
    i = 0;
    // const loggedInUser = useSelector((state) => state?.Auth?.user);
    userIDs.push(loggedInUser.userId);
    if(loggedInUser.roleId.level === 1){
getUsers1(userIDs,resolve)
    }else{
      getUserId(userIDs, resolve);
    }
    
  });
}
async function getApproverId(userIds, resolve) {
  // return new Promise(async (resolve, reject) => {

  const { data, error } = await supabase.from('Users').select('*, roleId(*)').eq('userId', userIds)
  if (data) {
    console.log('data: ', data);
    // data.forEach((id) => {
    for (let i = 0; i < data.length; i++) {
      const user = data[i];
      if (user.roleId?.accessibleTabs['All Allotments'] && user.roleId.accessibleTabs['All Allotments']['Change Unit Approver']) {
        userIds = user;
        break;
      }
    }
    // });
    i++;
    if (userIds === '') {
      getUserId(userIds, resolve);
    } else {
      console.log('userIds: ', userIds, i);
      resolve(userIds);
    }
  }
  // else throw error
  // });
}
async function getApproverInHierarchy(loggedInUser) {
  return new Promise((resolve, reject) => {
    const userIDs = loggedInUser.parentId.userId;
    i = 0;
    // const loggedInUser = useSelector((state) => state?.Auth?.user);
    // userIDs.push(loggedInUser.userId);
    // getApproverId(userIDs, resolve);
    // !!Sarita's change
    getApproverUserId(userIDs,resolve);
  })
}
async function getApproverUserId(userIds, resolve) {
  let approverUserId='';
    const { data, error } = await supabase.from('Users').select('*, roleId(*)').eq('userId', userIds)
    if (data) {
      console.log('data: ', data);
      // data.forEach((id) => {
        const user = data[0];
        if (user.roleId?.accessibleTabs['All Allotments'] && user.roleId.accessibleTabs['All Allotments']['Change Unit Approver']) {
          approverUserId = user;
      }
      if (approverUserId === '') {
        if(data[0].parentId===null){
          resolve(data[0]);
        }else{
          getApproverUserId(data[0].parentId, resolve);
        }
      } else {
        console.log('userIds: ', userIds, i);
        resolve(approverUserId);
      }
    }
    // else throw error
    // });
  }
async function getSuperAdminId(){
  const {data,error} =  await supabase.from('Users').select('*').eq('parentId',null)
  if (data) return data;
  else throw error;
}
async function sendResetPasswordMailCP(email) {
  const { data, error } = await supabase.auth.api.resetPasswordForEmail(email, { redirectTo: process.env.REACT_APP_CP_RESET_PASSWORD });
  if (data) return data;
  else throw error;
}
async function sendResetPasswordMailSales(email) {
  const { data, error } = await supabase.auth.api.resetPasswordForEmail(email, { redirectTo: process.env.REACT_APP_SALES_RESET_PASSWORD });
  if (data) return data;
  else throw error;
}
async function resetPassword(access_token, newPassword) {
  const { data, error } = await supabase.auth.api.updateUser(access_token, { password: newPassword })
  if (data) return data;
  else throw error;
}

async function logOut() {
	return await supabase.auth.signOut();
}

export {
  loginWithEmailPass, insertLoginLogs, signOut, getUser, getAllUser,getAllUserActive,
  handleErrors, getTeamHierarchy, sendResetPasswordMailCP,
  sendResetPasswordMailSales, resetPassword, getAllUserByName,
   getApproverInHierarchy,getSuperAdminId, logOut
}
